import type { DimensionScoreRecord } from '@sdd-maturity/shared-types';
import { scoreColor } from '../lib/score';

export interface ScoreDistributionProps {
  dimensions: DimensionScoreRecord[];
}

/** Mini horizontal bar chart showing per-dimension scores. */
export function ScoreDistribution({ dimensions }: ScoreDistributionProps) {
  if (dimensions.length === 0) return null;

  return (
    <div className="flex flex-col gap-sm mt-sm" data-testid="score-distribution">
      {dimensions.map((d) => (
        <div key={d.dimension} className="flex items-center gap-sm">
          <span
            className="text-xs text-secondary"
            style={{ width: '6rem', textTransform: 'capitalize' }}
          >
            {d.dimension.replace('-', ' ')}
          </span>
          <div className="dim-score-bar">
            <div
              className="dim-score-bar-fill"
              style={{
                width: `${Math.min(d.score, 100)}%`,
                backgroundColor: scoreColor(d.score),
              }}
            />
          </div>
          <span className="text-xs font-medium" style={{ width: '2rem', textAlign: 'right' }}>
            {d.score.toFixed(1)}
          </span>
        </div>
      ))}
    </div>
  );
}
